export function FIXED() {
	return {
		zonglan: [
			{
				el: "el-input",
				label: "标题1",
				name: "title1",
				attrs: {
					placeholder: "标题1",
				},
			},
			{
				el: "rich-text",
				label: "内容1",
				name: "descr1",
				attrs: {
					keyWord: "descr1",
					params: "",
				},
			},
			{
				el: "el-input",
				label: "标题2",
				name: "title2",
				attrs: {
					placeholder: "标题2",
				},
			},
			{
				el: "rich-text",
				label: "内容2",
				name: "descr2",
				attrs: {
					keyWord: "descr2",
					params: "",
				},
			},
			{
				el: "el-input",
				label: "标题3",
				name: "title3",
				attrs: {
					placeholder: "标题3",
				},
			},
			{
				el: "rich-text",
				label: "内容3",
				name: "descr3",
				attrs: {
					keyWord: "descr3",
					params: "",
				},
			},
			{
				el: "el-input",
				label: "标题4",
				name: "title4",
				attrs: {
					placeholder: "标题4",
				},
			},
			{
				el: "rich-text",
				label: "内容4",
				name: "descr4",
				attrs: {
					keyWord: "descr4",
					params: "",
				},
			},
		],
		qishi: [
			{
				el: "el-input",
				label: "标题1",
				name: "title1",
				attrs: {
					placeholder: "标题1",
				},
			},
			{
				el: "rich-text",
				label: "内容1",
				name: "descr1",
				attrs: {
					keyWord: "descr1",
					params: "",
				},
			},
			{
				el: "el-input",
				label: "标题2",
				name: "title2",
				attrs: {
					placeholder: "标题2",
				},
			},
			{
				el: "rich-text",
				label: "内容2",
				name: "descr2",
				attrs: {
					keyWord: "descr2",
					params: "",
				},
			},
			{
				el: "el-input",
				label: "标题3",
				name: "title3",
				attrs: {
					placeholder: "标题3",
				},
			},
			{
				el: "rich-text",
				label: "内容3",
				name: "descr3",
				attrs: {
					keyWord: "descr3",
					params: "",
				},
			},
			{
				el: "el-input",
				label: "标题4",
				name: "title4",
				attrs: {
					placeholder: "标题4",
				},
			},
			{
				el: "rich-text",
				label: "内容4",
				name: "descr4",
				attrs: {
					keyWord: "descr4",
					params: "",
				},
			},
		],
		liliang: [
			{
				el: "el-input",
				label: "标题1",
				name: "title1",
				attrs: {
					placeholder: "标题1",
				},
			},
			{
				el: "rich-text",
				label: "内容1",
				name: "descr1",
				attrs: {
					keyWord: "descr1",
					params: "",
				},
			},
			{
				el: "el-input",
				label: "标题2",
				name: "title2",
				attrs: {
					placeholder: "标题2",
				},
			},
			{
				el: "rich-text",
				label: "内容2",
				name: "descr2",
				attrs: {
					keyWord: "descr2",
					params: "",
				},
			},
			{
				el: "el-input",
				label: "标题3",
				name: "title3",
				attrs: {
					placeholder: "标题3",
				},
			},
			{
				el: "rich-text",
				label: "内容3",
				name: "descr3",
				attrs: {
					keyWord: "descr3",
					params: "",
				},
			},
			{
				el: "el-input",
				label: "标题4",
				name: "title4",
				attrs: {
					placeholder: "标题4",
				},
			},
			{
				el: "rich-text",
				label: "内容4",
				name: "descr4",
				attrs: {
					keyWord: "descr4",
					params: "",
				},
			},
		],
	};
}
